import _lib from '../_lib';
import active from './active/index';
import {ProviderNavigation} from '@/store/modules/fsm/messages';

export default ({tree,parent,api}) => {
  let regionName = 'provider';
  let activations = [
    {
      name: 'provider',
      test: api.messageIs(ProviderNavigation)
    }
  ];
  let activeIndex = active;
  let func = _lib({regionName,activations,activeIndex});
  return func({tree,parent,api});
};

